"use client";

import React from "react";

import { SVGIcon } from "../SVGIcon";
import { createSVGIcon } from "../util";

const getPath = (solid: boolean) =>
  solid ? (
    <>
      <path
        d="M15 7.78837C15 12.0898 7.5 18 7.5 18C7.5 18 0 12.0898 0 7.78837C0 3.48697 3.35786 0 7.5 0C11.6421 0 15 3.48697 15 7.78837Z"
        fill="currentColor"
      />
      <circle cx="7.5" cy="7.5" r="1.5" fill="white" />
    </>
  ) : (
    <>
      <path
        d="M14.5 7.79067C14.5 8.74372 14.0796 9.83037 13.3967 10.9537C12.7184 12.0696 11.8071 13.1792 10.8853 14.168C9.96493 15.1551 9.0431 16.0121 8.35062 16.6228C8.00469 16.9278 7.71675 17.1707 7.51583 17.3369C7.51049 17.3413 7.50522 17.3457 7.5 17.35C7.49478 17.3457 7.48951 17.3413 7.48417 17.3369C7.28325 17.1707 6.99531 16.9278 6.64937 16.6228C5.9569 16.0121 5.03507 15.1551 4.11472 14.168C3.19284 13.1792 2.28164 12.0696 1.60326 10.9537C0.920329 9.83037 0.5 8.74372 0.5 7.79067C0.5 3.73043 3.66785 0.5 7.5 0.5C11.3322 0.5 14.5 3.73043 14.5 7.79067Z"
        stroke="currentColor"
        fill="none"
      />
      <path
        d="M7.49991 8.99986C8.32833 8.99986 8.99991 8.32828 8.99991 7.49985C8.99991 6.67142 8.32833 5.99985 7.49991 5.99985C6.67148 5.99985 5.99991 6.67142 5.99991 7.49985C5.99991 8.32828 6.67148 8.99986 7.49991 8.99986Z"
        fill="currentColor"
      />
    </>
  );

const VIEWBOX = "0 0 15 18";

/**
 * @trackcomponent
 * @deprecated use Pin from foundation/Pin with fill
 */
export const LocationSolid = createSVGIcon(getPath(true), "Location", {
  viewBox: VIEWBOX,
});

/**
 * @trackcomponent
 * @deprecated use Pin from foundation/Pin
 */
export const Location = createSVGIcon(getPath(false), "Location", {
  viewBox: VIEWBOX,
});

/**
 * Dynamic version of the variants of the location icons.
 * @trackcomponent
 * @deprecated use Pin from foundation/Pin with fill
 */
export const LocationDynamic = React.memo(
  React.forwardRef<
    SVGElement,
    SVGIcon.IProps & {
      solid?: boolean;
    }
  >(({ solid = false, viewBox = VIEWBOX, ...props }, ref) => (
    <SVGIcon viewBox={viewBox} ref={ref} {...props}>
      {getPath(solid)}
    </SVGIcon>
  ))
);
